const languageData = [
  {
    languageId: 'english',
    locale: 'en',
    name: 'English',
    icon: 'us'
  },
  {
    languageId: 'spanish',
    locale: 'es',
    name: 'Español',
    icon: 'es'
  },
  {
    languageId: 'portuguese-brazil',
    locale: 'pt',
    name: 'Português (BR)',
    icon: 'br'
  }
];
export default languageData;
